// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"121":"c7b62d65","321":"d9310e48","675":"c7b62d65","695":"c7b62d65","828":"c7b62d65"}[chunkId] + ".chunk.css";
};